import type { CreateSessionInput, SessionResponse } from "@memorang/types";

const createSession = async (
	_input: CreateSessionInput,
): Promise<SessionResponse> => {
	return {
		id: "0",
		numericId: 0,
		sessionItems: [],
		sessionTime: 0,
		reportSessionType: "PRACTICETEST",
		hasMore: false,
		status: "ACTIVE",
		progressList: [],
	} satisfies SessionResponse;
};

export default createSession;
